export default function BrowniesPage () {
    return (
        <div class="flex justify-center min-h-screen">
            <div class="text-center max-w-2xl p-6">
                <h1 className="text-3xl font-bold text-center my-6">History of Our Lady Queen of Martyrs Brownies and Guides</h1>
                <h2 class="text-2xl font-semibold text-blue-800 mt-6 mb-6">by Anne Marie Cresham</h2>
                <p class="text-base text-black mb-6">
                    I was approached in 1988 by Fr Sean O'Connor, at the time, I was frequently at OLQM as 
                    I was chair of the deanery youth group who met there each Sunday for many years.
                </p>
                <p class="text-base text-black mb-6">
                    He knew I'd been involved with Brownies previously in my own parish of Our Lady of Sorrows and asked if I would 
                    consider opening a unit here. At the time there was a thriving and young congregation and his words were, we need 
                    something for the young ones, " If you start it off, I'll get a few good women to help you" and the rest is history.
                </p>
                <p className="text-base text-black mb-6">
                    With his Irish charm, he did find those good women and over the years, they have come and gone but we remain eternally 
                    grateful for their support which has enabled our unit to be active in our area for over 36yrs.
                </p>
                <p className="text-base text-black mb-6">
                    We opened a brownie and rainbow unit in 1989 . Guides followed in 1993, when those original brownies reached the age of 
                    10yrs and didn't want to leave, so I had no option then but to start guides.
                </p>
                <p className="text-base text-black mb-6">
                    At this time we had been meeting in the community room and the church but due to the large numbers and noise generated and
                    witnessed one night by one of the Salesian Sisters, we were generously offered space in the then Mary Help of Christians youth club.
                </p>
                <p className="text-base text-black mb-6">
                    The Salesian Sisters as trustees of the school have continued to provide us with accommodation over the years and we now meet in St 
                    John Bosco's Art College each Thursday night 6.30-8pm.
                </p>
                <p className="text-base text-black mb-6">
                    It still makes me smile when people say, I didn't know we had guides and brownies locally, well we do and we have had generations pass 
                    through our hands and now we have daughters of those original brownies, following in their Mums footsteps.
                    Three of our current leaders, were rainbows and brownies at OLQM and its a joy to see them passing on the fun, 
                    skills and memories they had to the next generation.
                </p>
                <p className="text-base text-black mb-6">
                    Joining is easy you can register at Girlguiding Go, click on "Join Us" and you'll find us registered as 8th Kirkby (Our Lady Queen of Martyrs) 
                    (It seems we were closer to Kirkby in 1989 but its always been an anomaly) input your daughters details, choose us as your first preference and 
                    we will receive an email and be in touch.
                    We are fully inclusive and will welcome you into our guiding family.
                </p>
            </div>
        </div>
    )
}